import { connect } from 'react-redux'
import { withProps, compose, lifecycle } from 'recompose'
import withType from 'components/common/hoc/withType'
import withViewHide from 'components/common/hoc/withViewHide'
import withSetBazaarVoiceInlineRatings from 'components/common/hoc/withBazaarVoiceInlineRatings/withSetBazaarVoiceInlineRatings'
import withGBBDetails from 'components/common/hoc/withGBBDetails/withGBBDetails'
import { googleAnalyticProductImpressions } from 'actions/googleAnalytic'
import { getPageLocation } from 'selectors'
import { getCurrentStoreNumber } from 'selectors/getCurrentStore'
import { getIsStoreLocatorModalInitialized } from 'selectors/storeLocatorModal'
import getActiveVehicle, {
  getActiveVehicleName,
  getActiveVehicleTireSize,
  getActiveVehicleFrontTireSize
} from 'selectors/getActiveVehicle'
import { getCompareTrayItems, getOeItemIdsList, getShowNoEligibleTiresForPromo, getOeFilterMode, getSectionsLabel } from '../selectors'

import {
  getRecommendedProductsSortedByPrice,
  checkRecommendedProductsVisibility,
  getGTMRecommendedProducts,
  getRecommendedProductColWidth,
  getRecommendedProductSkus,
  getShowRecommendedProductsInline,
  getGBBTitles
} from './helpers'
import BOTRecommendedSearchResult from './BOTRecommendedSearchResult'
import isEqual from 'lodash/isEqual'
import isEmpty from 'lodash/isEmpty'
import { isTablet } from 'components/common/Media/helpers'
import { getLocationSearch } from 'selectors/getPageLocation'
import { getFavoriteSkus } from 'components/MyFavorites/selectors'
import { setGbbProductsForInventory } from '../actions'
import { formatGBBProducts } from '../TireResultList/helpers'
import { getUserData } from 'components/Appointment/selectors'

const mapStateToProps = (state, props) => {
  const { resultsLabel } = getSectionsLabel(state, props)
  const { isPilotStore } = getUserData(state)

  return {
    resultsLabel,
    compatibilityLabel: getActiveVehicleTireSize(state),
    activeVehicle: getActiveVehicle(state),
    vehicleName: getActiveVehicleName(state),
    currentVehicleFrontTireSize: getActiveVehicleFrontTireSize(state),
    currentStoreNumber: getCurrentStoreNumber(state),
    search: getPageLocation(state).search,
    compareTrayItems: getCompareTrayItems(state),
    isStoreLocatorInitialized: getCurrentStoreNumber(state) || getIsStoreLocatorModalInitialized(state),
    hasFilters: !!(getLocationSearch(state)).length,
    showNoEligibleTiresForPromo: getShowNoEligibleTiresForPromo(state),
    favoriteSkus: getFavoriteSkus(state),
    oeItemIdsList: getOeItemIdsList(state),
    oeFilterMode: getOeFilterMode(state),
    isPilotStore
  }
}

const withSendAnalytic = lifecycle({
  componentDidMount() {
    const {
      isStoreLocatorInitialized,
      googleAnalyticProductImpressions,
      allTypes,
      favoriteSkus,
      oeItemIdsList
    } = this.props
    if (isStoreLocatorInitialized) {
      googleAnalyticProductImpressions({
        data: getGTMRecommendedProducts({ products: allTypes, favoriteSkus, oeItemIdsList })
      })
    }
  },

  componentDidUpdate(prevProps) {
    const {
      allTypes,
      isStoreLocatorInitialized,
      googleAnalyticProductImpressions,
      favoriteSkus,
      oeItemIdsList
    } = this.props
    const isStoreInitializedChanged = isStoreLocatorInitialized !== prevProps.isStoreLocatorInitialized

    if (isStoreLocatorInitialized && isStoreInitializedChanged) {
      googleAnalyticProductImpressions({
        data: getGTMRecommendedProducts({ products: allTypes, favoriteSkus, oeItemIdsList })
      })
    }
  }
})

const withSetGBBDetailsToStore = lifecycle({
  componentDidMount() {
    const {
      allTypes,
      titles,
      setAllGBBDetails,
      setGbbProductsForInventory,
      currentVehicleFrontTireSize,
      currentStoreNumber,
      isPilotStore
    } = this.props

    const recommendedProductSkus = getRecommendedProductSkus(allTypes, titles)

    if (isPilotStore) {
      !isEmpty(recommendedProductSkus)
        ? setGbbProductsForInventory(formatGBBProducts(recommendedProductSkus))
        : setGbbProductsForInventory([])
    }

    setAllGBBDetails({
      availability: !isEmpty(allTypes),
      gBB: recommendedProductSkus,
      tireSize: currentVehicleFrontTireSize,
      storeNumber: currentStoreNumber
    })
  },
  componentDidUpdate({
    allTypes: prevAllTypes,
    isPilotStore: prevIsPilotStore,
    currentStoreNumber: prevCurrentStoreNumber,
    vehicleName: prevVehicleName }) {
    const {
      allTypes,
      titles,
      setAllGBBDetails,
      currentVehicleFrontTireSize,
      currentStoreNumber,
      isPilotStore,
      setGbbProductsForInventory,
      vehicleName
    } = this.props
    const vehicleWasChanged = !isEqual(prevVehicleName, vehicleName)
    const storeWasChanged = !isEqual(currentStoreNumber, prevCurrentStoreNumber)

    if ((!isEqual(isPilotStore, prevIsPilotStore) || vehicleWasChanged || storeWasChanged) && isPilotStore) {
      const recommendedProductSkus = getRecommendedProductSkus(allTypes, titles)

      !isEmpty(recommendedProductSkus)
        ? setGbbProductsForInventory(formatGBBProducts(recommendedProductSkus))
        : setGbbProductsForInventory([])
    }

    if (!isEqual(allTypes, prevAllTypes)) {
      setAllGBBDetails({
        availability: !isEmpty(allTypes),
        gBB: getRecommendedProductSkus(allTypes, titles),
        tireSize: currentVehicleFrontTireSize,
        storeNumber: currentStoreNumber
      })
    }
  }
})

const withRecommendedSearchResultProps = withProps(({
  gBBDetails,
  search = '',
  vehicleName
}) => {
  const recommendedProducts = getRecommendedProductsSortedByPrice(gBBDetails)
  return {
    allTypes: recommendedProducts,
    isHorizontal: !isTablet() && recommendedProducts.length === 1,
    recommendedCount: recommendedProducts.length,
    colWidth: getRecommendedProductColWidth(recommendedProducts.length),
    isRecommendedResultsVisible: checkRecommendedProductsVisibility({
      products: recommendedProducts, query: search
    }),
    showInline: getShowRecommendedProductsInline(recommendedProducts.length),
    titles: getGBBTitles()
  }
})

export default compose(
  withType({
    type: 'BOTRecommendedSearchResult',
    placeholders: ['footer', 'mainContent', 'header']
  }),
  connect(mapStateToProps, { googleAnalyticProductImpressions, setGbbProductsForInventory }),
  withSetBazaarVoiceInlineRatings,
  withRecommendedSearchResultProps,
  withGBBDetails,
  withSetGBBDetailsToStore,
  withViewHide(({ isRecommendedResultsVisible, oeFilterMode }) => !isRecommendedResultsVisible || oeFilterMode),
  withSendAnalytic
)(BOTRecommendedSearchResult)
